










import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import ButtonMixin from "@/mixins/ButtonMixin";
import { v4 as uuidv4 } from "uuid";

@Component
export default class ActionButton extends mixins(ButtonMixin) {
  public name = "ActionButton";

  @Prop({ default: () => uuidv4() })
  public id!: string;

  @Prop()
  public tooltipLabel!: any;

  @Prop()
  public text!: any;

  @Prop()
  public icon!: Array<any>;

  @Prop()
  public disabled!: boolean;
}
